import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SassTokensService {
  isRendered: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
}
